import { z } from 'zod';
import { ERROR_CODES } from '../constants/error-codes.js';
export const apiErrorDetailSchema = z.object({
    path: z.string(),
    message: z.string(),
});
/** Feldgenaue Rückmeldung zu Zusatzfeldern, damit die Oberfläche direkt am Eingabefeld markieren kann. */
export const customFieldValidationIssueSchema = z.object({
    fieldKey: z.string(),
    fieldLabel: z.string(),
    reason: z.string(),
});
export const apiErrorSchema = z.object({
    /** Flache Felder für die direkte Anzeige; das `error`-Objekt bleibt für Bestandsclients erhalten. */
    success: z.literal(false).optional(),
    errorTrackingId: z.string().optional(),
    title: z.string().optional(),
    message: z.string().optional(),
    details: z.string().optional(),
    validationErrors: z.array(customFieldValidationIssueSchema).optional(),
    timestamp: z.string().optional(),
    error: z.object({
        code: z.nativeEnum(ERROR_CODES),
        /** Kurze Überschrift für Toasts und Dialoge; ohne Angabe leitet die UI sie aus dem Code ab. */
        title: z.string().optional(),
        message: z.string(),
        details: z.array(apiErrorDetailSchema).optional(),
        /** Handlungshinweis für den Benutzer, z. B. „Bitte Preis im Kundenstamm hinterlegen." */
        hint: z.string().optional(),
        traceId: z.string(),
        /** Referenz auf den Eintrag im Fehlerprotokoll; nur bei protokollierten Fehlern gesetzt. */
        trackingId: z.string().optional(),
        timestamp: z.string().optional(),
    }),
});
//# sourceMappingURL=api-error.js.map